/* eslint-disable*/
import {
  Box,
  CircularProgress,
  Dialog,
  Typography,
  DialogContent,
  TextField,
  Link
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect, useRef, memo } from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Grid,
  Button
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkSurvey,
  displayFlag,
  onceOpened,
  error,
  loading,
  sendSurvey,
  setDisplayFlag
} from 'feactures/survey/surveySlice';
import { useNavigate } from 'react-router-dom';

const NoticeDialog = () => {
  const [value, setValue] = useState('');
  const [reason, setReason] = useState('');
  const [buttonDisable, setButtunDisable] = useState(true);
  const [changeContent, setChangeContent] = useState('survey');
  const openFlag = useSelector(displayFlag);
  const onceOpenedFlag = useSelector(onceOpened);
  const loadingFlag = useSelector(loading);
  const errorFlag = useSelector(error);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const firstUpdate = useRef(true); // 初回レンダリングを特定するための変数

  useEffect(() => {
    if (!onceOpenedFlag) {
      //初回レンダリング時のみ起動（閉じた後にチャンネルを移動しても表示されないように）
      dispatch(checkSurvey());
    } else {
      return;
    }

    // if (firstUpdate.current) {
    //   // 初回レンダリング時
    //   firstUpdate.current = false; // 初回レンダリング終了を記録
    //   return; // useEffectの処理をスキップ
    // }

    if (errorFlag) {
      // 送信中にエラーが起きた場合1秒後に再度回答フォームを表示する
      setTimeout(() => {
        setChangeContent('survey');
      }, '1000');
    } else if (errorFlag == null) {
      return;
    } else {
      // 1秒後にポップアップを非表示にする
      setTimeout(() => {
        dispatch(setDisplayFlag(false));
      }, '1000');
    }
  }, [errorFlag]); // errorFlag の値が変わるたびに実行されます

  const handleButtonClick = () => {
    navigate('/app/news/3');
  };

  // ×ボタンクリックでポップアップを非表示にする。
  const handleClick = () => {
    dispatch(setDisplayFlag(false));
  };

  return (
    <>
      {openFlag && (
        <Dialog open={openFlag} onClose={handleClick} maxWidth="700px">
          <DialogContent
            sx={{
              display: 'flex',
              padding: '20px 20px',
              bgcolor: '#FFF8E5'
            }}
          >
            {loadingFlag ? (
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                direction="column"
              >
                <Grid item xs={12}>
                  <CircularProgress />
                </Grid>
              </Grid>
            ) : (
              <>
                {changeContent === 'survey' ? (
                  <Box
                    sx={{ padding: '10px 10px' }}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    my={1}
                    width="700px"
                    height="350px"
                  >
                    <Box
                      m={1}
                      px={5}
                      py={8}
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      bgcolor="#FFFFFF"
                    >
                      <Typography fontSize={30} fontWeight="bold" mb={1}>
                        Oxcimは4/16にリニューアルをしました！
                      </Typography>
                      <Typography fontSize={30} fontWeight="bold" mb={1}>
                        今なら初期費用無料キャンペーンあり！
                      </Typography>
                      <Typography fontSize={30} fontWeight="bold" mb={1}>
                        詳細は
                        <Link
                          fontSize={30}
                          target="_blank"
                          href="https://www.oxcim.net/update"
                        >
                          こちら
                        </Link>
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Grid container alignItems="center" justifyContent="center">
                    {errorFlag ? (
                      <>
                        <Grid item xs={12}>
                          <Typography fontSize={15} fontWeight="bold">
                            送信中にエラーが発生しました。
                          </Typography>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Grid item xs={12}>
                          <Typography
                            fontSize={15}
                            fontWeight="bold"
                            sx={{
                              textAlign: 'center'
                            }}
                          >
                            送信が完了しました。
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            fontSize={15}
                            fontWeight="bold"
                            sx={{
                              textAlign: 'center'
                            }}
                          >
                            ご回答ありがとうございました。
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                )}
              </>
            )}
            <CloseIcon
              onClick={handleClick}
              sx={{ alignSelf: 'flex-start', cursor: 'pointer' }}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default NoticeDialog;
